import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModulePlasticSurgery from '../../schemas/module-plastic-surgery.json';

export class SchemaModulePlasticSurgery extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModulePlasticSurgery );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-plastic-surgery.ts